import SecureLS from 'secure-ls';
export class StorageService {

  private readonly _ls = new SecureLS({encodingType: 'aes', isCompression: false});
  constructor() {
    // sessionStorage is cleared when the tab closes and is not shared with a new tab.
    // A refresh of this tab keeps the login. Opening the app in a new tab does not.
    const secureLs = this._ls as SecureLS & { ls: Storage; init: () => void };
    secureLs.ls = sessionStorage;
    secureLs.init();
  }

  set(key: string, value: any, expired: number = 0) {
    this._ls.set(key, value);
  }

  remove(key: string) {
    this._ls.remove(key);
  }

  get(key: string) {
    try {
      return this._ls.get(key);
    } catch (e) {
      sessionStorage.removeItem(key);
      return null;
    }
  }

  clear() {
    this._ls.removeAll();
  }
}
